import { render, staticRenderFns } from "./NewsDokumentUploadModal.vue?vue&type=template&id=ffc83cc6"
import script from "./NewsDokumentUploadModal.vue?vue&type=script&lang=js"
export * from "./NewsDokumentUploadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports